import './selectDropdown.scss';

import * as React from 'react';
import Select from 'react-select';

import { ISelectOptions } from '../../interfaces';

export interface ISelectDropdownProps {
    menuItems: ISelectOptions[];
    onChange: Function;
    defaultValue?: string;
    placeholder?: string;
}

export interface ISelectDropdownState {
    selectedValue: string;
}

export class SelectDropdown extends React.PureComponent<ISelectDropdownProps, ISelectDropdownState> {
    constructor(props: ISelectDropdownProps) {
        super(props);
        this.state = { selectedValue: props.defaultValue || '' };
    }

    handleChange = (obj) => {
        this.setState({ selectedValue: obj.value });
        this.props.onChange(obj.value);
    }

    componentWillReceiveProps(nextProps: ISelectDropdownProps) {
        if (this.props.defaultValue !== nextProps.defaultValue) {
            this.setState({
                selectedValue: nextProps.defaultValue
            });
        }
    }

    render() {
        return <div className="select-dropdown" >
            <Select
                className=""
                value={this.state.selectedValue}
                onChange={this.handleChange}
                options={this.props.menuItems}
                placeholder={this.props.placeholder}
                clearable={false}
            />
        </div>;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/SelectDropdown.tsx